import { render, staticRenderFns } from "./Light.vue?vue&type=template&id=b4af021c&scoped=true&"
import script from "./Light.vue?vue&type=script&lang=js&"
export * from "./Light.vue?vue&type=script&lang=js&"
import style0 from "./Light.vue?vue&type=style&index=0&id=b4af021c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4af021c",
  null
  
)

export default component.exports